export const password = v => {
  // at least one uppercase, lowercase, and special character
  const cases = [/[A-Z]/, /[a-z]/, /[^A-Za-z0-9]/];
  return !v || cases.every(c => c.test(v));
};
